

export function ReceiptFilters({ filter, filtered, items, setFilter }) {
  return (
    <>
      <div className="flex items-center gap-2 flex-wrap mb-4">
        {[
          { v: "todos", label: "Todos" },
          { v: "emitido", label: "Emitidos" },
          { v: "cancelado", label: "Cancelados" },
        ].map((s) => (
          <button
            key={s.v}
            data-testid={`receipt-filter-${s.v}`}
            onClick={() => setFilter(s.v)}
            className={`px-3 py-1.5 text-[11px] uppercase tracking-[0.22em] border rounded-sm ${
              filter === s.v
                ? "bg-[#0A0F14] text-white border-[#0A0F14]"
                : "bg-white text-slate-700 border-slate-300 hover:border-[#002776]"
            }`}
          >
            {s.label}
          </button>
        ))}
        {items && (
          <span className="ml-auto text-[11px] uppercase tracking-[0.22em] text-slate-500">
            {filtered.length} recibo(s)
          </span>
        )}
      </div>

    </>
  );
}
